<ng-container *ngIf="!!get">
    <tt-card class="tt-email-create__info" ttHeading="h_info" ttIcon="far fa-info-circle">
        <div class="tt-email-create__info-content">
            <mgt-login style="width: fit-content; min-width: 10rem"></mgt-login>
            <div style="flex: 1; width: 100%">
                <tt-input *ngIf="get.cust_no > '0'" ttLabel="cust_name" [(ttModel)]="get.cust_name" ttReadonly>
                    <tt-form-field-button
                        buttons
                        ttIcon="fas fa-chevron-right"
                        ttGoto="customerpersons"
                        [ttGotoParms]="{ cust_no: get.cust_no }"
                        ttTooltip="goto_customerpersons"
                        [ttTranslateTooltip]="true"
                    ></tt-form-field-button>
                </tt-input>
                <tt-select ttLabel="emailtemplate" [(ttModel)]="get.emailtemplate_keyno" (ttModelChange)="loadEmailCreateGet()" [ttData]="emailTemplates" ttShowClearButton>
                    <ng-container buttons>
                        <tt-form-field-button ttIcon="fas fa-bars" ttTooltip="goto_emailtemplates" [ttTranslateTooltip]="true" ttGoto="emailtemplates"></tt-form-field-button>
                        <tt-form-field-button
                            *ngIf="get.emailtemplate_keyno > '0'"
                            ttIcon="fas fa-chevron-right"
                            ttTooltip="goto_emailtemplate"
                            [ttTranslateTooltip]="true"
                            ttGoto="emailtemplate"
                            [ttGotoParms]="{ emailtemplate_keyno: get.emailtemplate_keyno }"
                        ></tt-form-field-button>
                    </ng-container>
                </tt-select>
            </div>
        </div>
        <tt-input ttLabel="from_email" [(ttModel)]="get.from_email">
            <tt-form-field-button
                *ngIf="get.show_setting === '1'"
                buttons
                ttIcon="fas fa-cog"
                ttTooltip="goto_businesscosettingsmtp"
                [ttTranslateTooltip]="true"
                ttType="warning"
                [ttBeforeGoto]="rememberEmailCreate"
                ttGoto="businesscosettingsmtp"
                [ttGotoParms]="{ businessco_no: get.businessco_no }"
            ></tt-form-field-button>
        </tt-input>
    </tt-card>
    <tt-card class="tt-email-create__recipients" ttHeading="h_recipients" ttIcon="far fa-users" ttAccordion>
        <tt-search-multi-select
            ttLabel="recipient_email"
            ttModelSetting="stringId"
            [(ttModel)]="get.recipient_email"
            [ttData]="searchEmailRecipients"
            ttDataId="email"
            ttSearchDebounce="500"
            ttSearchMinLength="3"
            ttShowClearButton
        >
            <ng-container buttons>
                <tt-form-field-button
                    ttIcon="fas fa-plus"
                    ttTooltip="goto_emailadd"
                    [ttTranslateTooltip]="true"
                    [ttBeforeGoto]="rememberEmailCreate"
                    ttGoto="emailadd"
                    [ttGotoParms]="{ argtype: get.argtype, argvalue: get.argvalue, functionname: 'to' }"
                ></tt-form-field-button>
            </ng-container>
        </tt-search-multi-select>
        <tt-search-multi-select
            ttLabel="copy_email"
            ttModelSetting="stringId"
            [(ttModel)]="get.copy_email"
            [ttData]="searchEmailRecipients"
            ttDataId="email"
            ttSearchDebounce="500"
            ttSearchMinLength="3"
            ttShowClearButton
        >
            <ng-container buttons>
                <tt-form-field-button
                    ttIcon="fas fa-plus"
                    ttTooltip="goto_emailadd"
                    [ttTranslateTooltip]="true"
                    [ttBeforeGoto]="rememberEmailCreate"
                    ttGoto="emailadd"
                    [ttGotoParms]="{ argtype: get.argtype, argvalue: get.argvalue, functionname: 'copy' }"
                ></tt-form-field-button>
            </ng-container>
        </tt-search-multi-select>
        <tt-search-multi-select
            ttLabel="bcc_email"
            ttModelSetting="stringId"
            [(ttModel)]="get.bcc_email"
            [ttData]="searchEmailRecipients"
            ttDataId="email"
            ttSearchDebounce="500"
            ttSearchMinLength="3"
            ttShowClearButton
        >
            <ng-container buttons>
                <tt-form-field-button
                    ttIcon="fas fa-plus"
                    ttTooltip="goto_emailadd"
                    [ttTranslateTooltip]="true"
                    [ttBeforeGoto]="rememberEmailCreate"
                    ttGoto="emailadd"
                    [ttGotoParms]="{ argtype: get.argtype, argvalue: get.argvalue, functionname: 'bcc' }"
                ></tt-form-field-button>
            </ng-container>
        </tt-search-multi-select>
    </tt-card>

    <tt-card class="tt-email-create__contents" ttHeading="h_contents" ttIcon="far fa-envelope" ttAccordion>
        <div style="display: flex; align-items: flex-end; width: 100%; gap: 5px">
            <tt-button-save
                ttText="emailcreate_send"
                ttIcon="fas fa-paper-plane"
                (ttClick)="sendEmail()"
                ttLoadingText="sending_email"
                [ttLoading]="sending"
                [ttDisabled]="editorProcessing"
                style="display: block; width: 10rem"
            ></tt-button-save>
            <tt-input ttLabelView="top" ttLabel="email_heading" [(ttModel)]="get.email_heading" style="flex: 1"></tt-input>
        </div>
        <div *ngIf="showExternalDocumentsTab && includedAttachments.length > 0" class="tt-email-create__included-attachments">
            <div *ngFor="let attachment of includedAttachments; trackBy: trackIncludedAttachment" class="tt-email-create__included-attachment">
                <span class="tt-email-create__included-attachment-icon fa-fw" [ngClass]="attachment.icon" [style.color]="attachment.iconColor"></span>
                <span class="tt-email-create__included-attachment-content" [matTooltip]="attachment.name" matTooltipShowDelay="1000">
                    <span class="tt-email-create__included-attachment-name">{{ attachment.name }}</span>
                    <span class="tt-email-create__included-attachment-subtitle">
                        <span [ttTranslateWord]="attachment.sourceTranslation"></span>
                        <ng-container *ngIf="attachment.size !== undefined"> · {{ formatFileSize(attachment.size) }}</ng-container>
                    </span>
                </span>
                <button
                    type="button"
                    class="tt-button tt-email-create__included-attachment-remove"
                    [attr.aria-label]="'Remove ' + attachment.name"
                    (click)="removeIncludedAttachment(attachment)"
                >
                    <span class="far fa-times" aria-hidden="true"></span>
                </button>
            </div>
        </div>
        <tt-editor ttLabel="email_body" [(ttModel)]="get.email_body" [(ttProcessing)]="editorProcessing"></tt-editor>
    </tt-card>

    <tt-card class="tt-email-create__attachments" ttHeading="h_attachments" ttIcon="far fa-paperclip" ttAccordion>
        <tt-tabs [(ttSelectedId)]="selectedAttachmentTab" (ttSelectedIdChange)="onAttachmentTabChanged($event)">
            <tt-tab ttId="REPORT" ttLabel="bg_attatchment_report"></tt-tab>
            <tt-tab *ngIf="hasDocumentTabs" ttId="FILE" ttLabel="bg_attatchment_file"></tt-tab>
            <tt-tab *ngIf="showExternalDocumentsTab" ttId="EXTERNAL" ttLabel="bg_attatchment_external"></tt-tab>
        </tt-tabs>
        <div *ngIf="showExternalDocumentsTab && selectedAttachmentTab === 'EXTERNAL'">
            <tt-file-uploader ttLabelView="top" ttLabel="upload_external_attachments" [(ttFiles)]="externalAttachments" ttDropZone ttMultiple></tt-file-uploader>
            <hr class="col-xs-12 sp-0 k-hr" />
            <h3 class="tt-card__heading col-xs-12 sp-0"><span class="fa-fw far fa-image"></span> <span ttTranslateWord="pictures_in_picturebank"></span></h3>
            <tt-tabs [(ttSelectedId)]="selectedSirvTab">
                <tt-tab *ngIf="showArgtypeDocumentsTab" ttId="ARGTYPE" [ttLabel]="argtypeDocumentsLabel"></tt-tab>
                <tt-tab *ngIf="showCustomerDocumentsTab" ttId="CUSTOMER" ttLabel="bg_attatchdocs_customer"></tt-tab>
                <tt-tab *ngIf="showProductDocumentsTab" ttId="PRODUCT" ttLabel="bg_attatchdocs_products"></tt-tab>
                <tt-tab *ngIf="showCustactDocumentsTab" ttId="CUSTACT" ttLabel="bg_attatchdocs_custact"></tt-tab>
            </tt-tabs>
            <div class="tt-email-create__sirv-images">
                <img
                    *ngFor="let sirvImage of sirvImages; trackBy: trackSirvImage"
                    class="tt-email-create__sirv-image"
                    [src]="getSirvImageUrl(sirvImage.full_url)"
                    (click)="prependSirvImage(sirvImage)"
                    alt=""
                    loading="lazy"
                    decoding="async"
                />
            </div>
        </div>
        <tt-tabs [hidden]="selectedAttachmentTab !== 'FILE' || !hasDocumentTabs" [(ttSelectedId)]="selectedDocsTab">
            <tt-tab *ngIf="showArgtypeDocumentsTab" ttId="ARGTYPE" [ttLabel]="argtypeDocumentsLabel"></tt-tab>
            <tt-tab *ngIf="showCustomerDocumentsTab" ttId="CUSTOMER" ttLabel="bg_attatchdocs_customer"></tt-tab>
            <tt-tab *ngIf="showProductDocumentsTab" ttId="PRODUCT" ttLabel="bg_attatchdocs_products"></tt-tab>
            <tt-tab *ngIf="showCustactDocumentsTab" ttId="CUSTACT" ttLabel="bg_attatchdocs_custact"></tt-tab>
        </tt-tabs>
        <tt-button-settings
            *ngIf="get.show_setting === '1' && selectedAttachmentTab === 'FILE' && hasDocumentTabs"
            ttText="document_settings"
            ttWebpageName="documents"
            (ttClick)="openDocumentSettings($event)"
        ></tt-button-settings>
        <div [hidden]="selectedAttachmentTab !== 'FILE' || (selectedDocsTab !== 'CUSTOMER' && selectedDocsTab !== 'ARGTYPE' && selectedDocsTab !== 'PRODUCT')">
            <tt-input [hidden]="selectedDocsTab !== 'CUSTOMER'" ttLabel="search" [(ttModel)]="get.customer_filtervalue" ttShowClearButton></tt-input>
            <tt-input [hidden]="selectedDocsTab !== 'ARGTYPE'" ttLabel="search" [(ttModel)]="get.order_filtervalue" ttShowClearButton></tt-input>
            <tt-input [hidden]="selectedDocsTab !== 'PRODUCT'" ttLabel="search" [(ttModel)]="get.product_filtervalue" ttShowClearButton></tt-input>
        </div>
        <tt-list [hidden]="selectedAttachmentTab !== 'REPORT'" ttCheckboxSelection [(ttData)]="reports" ttGoto="false" ttButtonsPosition="left" [ttButtons]="reportListButtons"></tt-list>
        <div [hidden]="selectedAttachmentTab !== 'FILE' || !hasDocumentTabs">
            <tt-list
                [hidden]="selectedDocsTab !== 'CUSTOMER'"
                ttCheckboxSelection
                [ttFilter]="get.customer_filtervalue"
                [(ttData)]="customerDocuments"
                ttGoto="false"
                ttButtonsPosition="left"
                [ttButtons]="documentListButtons"
            ></tt-list>
            <tt-list
                [hidden]="selectedDocsTab !== 'ARGTYPE'"
                ttCheckboxSelection
                [ttFilter]="get.order_filtervalue"
                [(ttData)]="argtypeDocuments"
                ttGoto="false"
                ttButtonsPosition="left"
                [ttButtons]="documentListButtons"
            ></tt-list>
            <tt-list
                [hidden]="selectedDocsTab !== 'PRODUCT'"
                ttCheckboxSelection
                [ttFilter]="get.product_filtervalue"
                [(ttData)]="productDocuments"
                ttGoto="false"
                ttButtonsPosition="left"
                [ttButtons]="documentListButtons"
            ></tt-list>
            <tt-list [hidden]="selectedDocsTab !== 'CUSTACT'" ttCheckboxSelection [(ttData)]="custactDocuments" ttGoto="false" ttButtonsPosition="left" [ttButtons]="documentListButtons"></tt-list>
        </div>
    </tt-card>
    <tt-card class="tt-email-create__settings">
        <tt-button-goto ttText="emailcreate_edit_signature" ttGoto="portalusersignature" [ttGotoParms]="{ portal_user_keyno: get.portal_user_keyno }"></tt-button-goto>
        <tt-button-settings *ngIf="get.show_setting === '1'" ttWebpageName="emailcreate" (ttClick)="openEmailCreateSettings($event)"></tt-button-settings>
    </tt-card>
</ng-container>

<!-- 


            <div class="col-xs-12 col-md-12 sp-5" style="margin-top: 5px; margin-bottom: 5px;">
                <div class="well well-sm col-xs-12">
                    <tt-input class="col-xs-12 sp-0" tt-label="email_heading" tt-model="vm.model.edit.email_heading" tt-change="vm.model.edit.email_heading = $value" tt-placeholder=""></tt-input>
                    <tt-text-editor tt-label="email_body" tt-model="vm.model.edit.email_body" tt-change="vm.model.edit.email_body = $value" tt-readonly="false" tt-ready="vm.model.readyEmailBody" tt-style="vm.style.editor"></tt-text-editor>
                    <tt-button-save class="col-xs-12 sp-0" tt-text="emailcreate_send" tt-locked="" tt-click="vm.sendEmail()" tt-text-align="center"></tt-button-save>
                    <tt-button-group list-items="vm.model.bgAttatchment.records" optionfunc="vm.selectBgAttatchment(item)" active-btn="vm.model.bgAttatchment.default" class="col-xs-12 sp-0"></tt-button-group>
                    <div ng-if="vm.model.bgAttatchment.selected === 'FILE'">
                        <tt-button-group list-items="vm.model.bgAttatchDocs.records" optionfunc="vm.selectBgAttatchDocs(item)" active-btn="vm.model.bgAttatchDocs.default" class="col-xs-12 sp-0"></tt-button-group>
                        <div ng-if="vm.model.bgAttatchDocs.selected === 'CUSTOMER'">
                            <tt-input-buttons class="col-xs-12 sp-0" tt-label="search" tt-model="vm.model.edit.customer_filtervalue" tt-change="vm.model.edit.customer_filtervalue = $value" tt-placeholder="" tt-buttons="vm.model.customerFilterValueButtons" tt-readonly="false"></tt-input-buttons>
                        </div>
                        <div ng-if="vm.model.bgAttatchDocs.selected === 'PRODUCT'">
                            <tt-input-buttons class="col-xs-12 sp-0" tt-label="search" tt-model="vm.model.edit.product_filtervalue" tt-change="vm.model.edit.product_filtervalue = $value" tt-placeholder="" tt-buttons="vm.model.productFilterValueButtons" tt-readonly="false"></tt-input-buttons>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-xs-12 col-md-12 sp-5" style="margin-top: 5px; margin-bottom: 5px;">
                <div ng-if="vm.model.bgAttatchment.selected === 'REPORT'">
                    <im-list-directive list-items="vm.model.p2SelectReportAttachList" badge="" ltype="custom" optionfunc="vm.toggleChosenReport(item)" design-var="s12"></im-list-directive>
                </div>
                <div ng-if="vm.model.bgAttatchment.selected === 'FILE'">
                    <div ng-if="vm.model.bgAttatchDocs.selected === 'CUSTOMER'">
                        <tt-checkbox-list [(tt-data)]="vm.model.p2DocumentsListCustNo" [tt-filter]="vm.model.edit.customer_filtervalue" tt-goto="false" [tt-buttons]="vm.model.documentListButtons" [tt-buttons-position]="'left'"></tt-checkbox-list>
                    </div>
                    <div ng-if="vm.model.bgAttatchDocs.selected === 'ORDER'">
                        <tt-checkbox-list [(tt-data)]="vm.model.p2DocumentsListOrderInternalNo" [tt-filter]="vm.model.edit.order_filtervalue" tt-goto="false" [tt-buttons]="vm.model.documentListButtons" [tt-buttons-position]="'left'"></tt-checkbox-list>
                    </div>
                    <div ng-if="vm.model.bgAttatchDocs.selected === 'PRODUCT'">
                        <tt-checkbox-list [(tt-data)]="vm.model.p2DocumentsList" [tt-filter]="vm.model.edit.product_filtervalue" tt-goto="false" [tt-buttons]="vm.model.documentListButtons" [tt-buttons-position]="'left'"></tt-checkbox-list>
                    </div>
                    <div ng-if="vm.model.bgAttatchDocs.selected === 'CUSTACT'">
                        <tt-checkbox-list [(tt-data)]="vm.model.p2DocumentsListCustactNo" [tt-filter]="vm.model.edit.custact_filtervalue" tt-goto="false" [tt-buttons]="vm.model.documentListButtons" [tt-buttons-position]="'left'"></tt-checkbox-list>
                    </div>
                </div>
            </div>

            <div class="col-xs-12 col-md-12 sp-5" style="margin-top: 5px; margin-bottom: 5px;">
                <div class="well well-sm col-xs-12">
                    <tt-button-goto class="col-xs-12 sp-0" tt-text="emailcreate_edit_signature" tt-goto-func="vm.goToFunc" tt-goto-parms="'portalusersignature'" tt-text-align="left"></tt-button-goto>
                    <div ng-if="vm.model.edit.show_setting === '1'">
                        <tt-button-settings class="col-xs-12 sp-0" tt-locked=""></tt-button-settings>
                    </div>
                </div>
            </div>
        </form>
    </div>
</section>
<section class="emailcreate">
    <div class="row-fluid">
        <form class="form-horizontal sp-0" name="formEmailCreate" novalidate method="get" role="form">
            <div class="col-xs-12 col-md-12 sp-5" style="margin-top: 5px; margin-bottom: 5px;">
                <div ng-if="vm.model.edit.emailcreate_heading > ''">
                    <tt-header tt-model="vm.model.edit.emailcreate_heading"></tt-header>
                </div>
                <div class="well well-sm col-xs-12">
                    <mgt-login></mgt-login>
                </div>
            </div>

            <div class="col-xs-12 col-md-6 sp-5" style="margin-top: 5px; margin-bottom: 5px;">
                <div class="well well-sm col-xs-12">
                    <div ng-if="vm.model.edit.cust_no > 0">
                        <tt-input-buttons class="col-xs-12 sp-0" tt-label="cust_name" tt-model="vm.model.edit.cust_name" tt-change="vm.model.edit.cust_name = $value" tt-placeholder="" tt-buttons="vm.model.custNameButtons" tt-readonly="true"></tt-input-buttons>
                    </div>
                    <div ng-if="vm.model.edit.emailtemplate_keyno === '0'">
                        <tt-select-buttons class="col-xs-12 sp-0" tt-label="emailtemplate" tt-model="vm.model.edit.emailtemplate_keyno" tt-change="vm.handleFieldChanged($value, $modelId)" tt-data="vm.model.selectListEmailTemplates" tt-data-id="item_id" tt-data-name="item_name" tt-buttons="vm.model.emailTemplateButtons"></tt-select-buttons>
                    </div>
                    <div ng-if="vm.model.edit.emailtemplate_keyno > 0">
                        <tt-select-buttons class="col-xs-12 sp-0" tt-label="emailtemplate" tt-model="vm.model.edit.emailtemplate_keyno" tt-change="vm.handleFieldChanged($value, $modelId)" tt-data="vm.model.selectListEmailTemplates" tt-data-id="item_id" tt-data-name="item_name" tt-buttons="vm.model.emailTemplateButtons2"></tt-select-buttons>
                    </div>
                    <tt-search-multi-select class="col-xs-12 sp-0" tt-label="recipient_email" [(tt-model)]="vm.model.edit.recipient_email" tt-search-debounce="500" tt-search-min-length="3" [tt-data]="vm.searchEmailContacts" tt-data-id="email" [tt-buttons]="vm.model.recipientEmailButtons"></tt-search-multi-select>
                </div>
            </div>

            <div class="col-xs-12 col-md-6 sp-5" style="margin-top: 5px; margin-bottom: 5px;">
                <div class="well well-sm col-xs-12">
                    <tt-input class="col-xs-12 sp-0" tt-label="from_email" tt-model="vm.model.edit.from_email" tt-change="vm.model.edit.from_email = $value" tt-placeholder=""></tt-input>
                    <tt-search-multi-select class="col-xs-12 sp-0" tt-label="copy_email" [(tt-model)]="vm.model.edit.copy_email" tt-search-debounce="500" tt-search-min-length="3" [tt-data]="vm.searchEmailContacts" tt-data-id="email" [tt-buttons]="vm.model.copyEmailButtons" tt-show-clear-button></tt-search-multi-select>
                    <tt-search-multi-select class="col-xs-12 sp-0" tt-label="bcc_email" [(tt-model)]="vm.model.edit.bcc_email" tt-search-debounce="500" tt-search-min-length="3" [tt-data]="vm.searchEmailContacts" tt-data-id="email" [tt-buttons]="vm.model.edit.show_setting === '1' ? vm.model.bbcEmailButtons2 : vm.model.bbcEmailButtons" tt-show-clear-button></tt-search-multi-select>
                </div>
            </div> -->
